import { Paper, useMantineTheme,Space } from '@mantine/core';
import { useMediaQuery } from "@mantine/hooks";

const getPadding = (isXs, accountPaper) => {
    if (isXs) {
        return '0px 25px';
    }
    if (accountPaper) {
        return '0px';
    }
    return '30px';
}

const FormPaper = ({ children, accountPaper=false }) => {

    const theme = useMantineTheme();
    const isXs = useMediaQuery(`(max-width: ${theme.breakpoints.xs}px)`);

    const paperStyles = {
        padding: getPadding(isXs, accountPaper),
    }

    return (
        <Paper
            shadow= {isXs ? 0: "sm"}
            withBorder = {isXs ? false : true}
            radius={isXs ? 0 : "lg"}
            sx = {paperStyles}
        >
            {isXs && <><Space h='xl' /></>}
            {children}
        </Paper>
    );
}

export default FormPaper;